import OrganisationApi from '@packages/organisations/api';

export class NomineeApi extends OrganisationApi {
    static resource = 'nominees';
}

export default NomineeApi;
